<template>
  <div @touchmove.self="stopMove">
    <section id="signUp" v-show="signUp">
      <div class="top">
        <div class="top-left"></div>
        <div class="top-right"></div>
      </div>
      <div class="content">
        <div class="info-wrap">
          <div class="item select">选择城市
            <select class="city" v-model="form.city" :class="{changeCity: isCity}" @change="getSchoolList">
              <option value='请选择所在城市' selected>请选择所在城市</option>
              <option v-for="item in cityList" :value ="item" :key="item">{{item}}</option>
            </select>
          </div>
          <div class="item">寿星姓名<input type="text" v-model="form.name" placeholder="请输入寿星姓名"></div>
          <div class="item">联系电话<input type="text" v-model="form.phone" placeholder="请输入联系电话" @keyup="filterNumber" maxlength="11"></div>
          <div class="item select" @click="checkShool">所在学校<input type="text" v-model="form.school" placeholder="请输入所在学校" maxlength="18"></div>
          <!-- <div class="item select">所在学校
            <select class="school" v-model="form.school" :class="{changeSchool: isSchool}">
              <option value='请选择所在学校' selected>请选择所在学校</option>
              <option v-for="item in school" :value ="item" :key="item">{{item}}</option>
            </select>
          </div> -->
          <div class="item select">出生年月<div id="birthday" v-html="form.birthday" :class="{changeColor: isTime}" @click="speak"></div></div>
        </div>
        <div class="tips-wrap">
          <div class="tips">温馨提示:</div>
          <div class="detail">请提交真实信息，出生年月以身份证为准，高校信息以学生证为准，小海马后台审核哦！</div>
        </div>
      </div>
      <div class="footer">
        <div class="submit" @click="submit"></div>
      </div>
    </section>
    <section class="success" v-show="!signUp">
      <header></header>
      <div class="user-wrap">
        <div>{{form.name}}</div>
        <div>{{number}}</div>
      </div>
      <img class="qrCode" :src="require('@/assets/happyBirthday/qrCode.png')">
      <div class="share" @click="needMask = true"></div>
      <div class="logo"></div>
    </section>
    <by-search v-show="showCheck" :list="school" @check="getSchool" @close="showCheck = false"></by-search>
    <div class="mask" v-show="needMask" @click="needMask = false">
      <div class="to-share"></div>
    </div>
    <!-- <section v-show="!signUp" id="canvas-wrap">
      <canvas width="750" height="1206" id="canvas" style="display: none"></canvas>
      <img :src="imgSrc" class="success-img">
    </section> -->
    <template>
      <mt-datetime-picker
        ref="picker"
        type="date"
        year-format="{value} 年"
        month-format="{value} 月"
        date-format="{value} 日"
        :closeOnClickModal="false"
        @confirm="handleConfirm"
        @cancel="cancel"
        :visibleItemCount="5"
        :startDate="start"
        v-model="time">
      </mt-datetime-picker>
    </template>
  </div>
</template>

<script>
import bySearch from '@/components/bySearch'
import {util} from '@/common/city.js'
export default {
  name: 'signUp',
  components: {
    'by-search': bySearch
  },
  data () {
    return {
      form: {
        name: '',
        phone: '',
        school: '',
        city: '请选择所在城市',
        birthday: '请选择出生年月',
        wechat_info: {}
      },
      showCheck: false,
      school: [],
      cityList: [],
      schoolList: [],
      imgSrc: '',
      number: '',
      isIpx: false,
      needMask: false,
      // 报名成功
      signUp: true,
      pickerValue: false,
      time: new Date('1995/07/01'),
      start: new Date('1970/07/01'),
      userInfo: {},
      datePicker: false,
      defaultResult: []
    }
  },
  computed: {
    isTime () {
      if (this.form.birthday !== '请选择出生年月') {
        return true
      }
    },
    isCity () {
      if (this.form.city !== '请选择所在城市') {
        return true
      }
    },
    isSchool () {
      if (this.form.school !== '请选择所在学校') {
        return true
      }
    },
    filterResult () {
      return this.defaultResult.filter(value => new RegExp(this.value, 'i').test(value))
    }
  },
  methods: {
    stopMove (e) {
      if (this.showCheck) {
        e.preventDefault()
      }
    },
    checkShool () {
      if (this.form.city === '请选择所在城市') {
        this.$toast('请先选择城市')
        return false
      }
      setTimeout(() => {
        window.scrollTo(0, 0)
        this.showCheck = true
      }, 300)
    },
    getSchool (val) {
      this.form.school = val
    },
    showMask () {
      this.needMask = true
    },
    cancel (e) {
      this.datePicker = false
      this.$refs.picker.close()
    },
    submit () {
      let userInfo = this.$store.state.userInfo
      if (!userInfo.headimgurl || !userInfo.openid) {
        this.$toast('报名需要在微信端打开')
        return false
      }
      let postUrl = 'https://mantu-tech-micro-api-proxy.api.hzmantu.com/himo_activity/add_item'
      let postData = {}
      if (!this.form.name) {
        this.$toast('请填写姓名')
        return false
      }
      if (this.form.school === '请选择所在学校') {
        this.$toast('请选择学校')
        return false
      }
      if (this.form.city === '请选择所在城市') {
        this.$toast('请选择城市')
        return false
      }
      if (this.form.birthday === '请选择出生年月') {
        this.$toast('请选择出生年月')
        return false
      }
      if (this.form.phone.length !== 11) {
        this.$toast('请输入正确手机号')
        return false
      }
      postData.activity_id = 'DABjRCuSu9nKHWtlfolir01EdDWQ4veM'
      let sexNum = this.$store.state.userInfo.sex
      let sexStr = ''
      if (+sexNum === 1) {
        sexStr = '男'
      } else if (+sexNum === 2) {
        sexStr = '女'
      } else {
        sexStr = '未知'
      }
      postData.sex = sexStr
      this.$indicator.open()
      postData.activity_content = JSON.parse(JSON.stringify(this.form))
      this.$axios.post(postUrl, postData).then(res => {
        this.$indicator.close()
        this.$toast('报名成功')
        this.signUp = false
        this.number = '编号 ' + res.data.msg.no
        // this.drawImage()
      }).catch(err => {
        this.$indicator.close()
        if (err.response.data.error_msg === 'user limit') {
          this.$toast('已经报过名了')
        }
      })
    },
    move (e) {
      if (this.datePicker) {
        e.preventDefault()
      }
    },
    drawImage () {
      let canvas = document.getElementById('canvas')
      let ctx = canvas.getContext('2d')
      let img = new Image()
      img.onload = (res) => {
        ctx.font = '30px Arial'
        ctx.drawImage(img, 0, 0, 750, 1206)
        ctx.textAlign = 'center'
        ctx.fillStyle = '#083760'
        ctx.fillText(this.form.name, 375, 720)
        ctx.fillText(this.number, 375, 770)
        this.imgSrc = canvas.toDataURL('image/png', 1)
      }
      img.src = require('@/assets/happyBirthday/successBg.png')
    },
    filterNumber (event) {
      event.target.value = event.target.value.replace(/[^\d]/g, '')
    },
    handleConfirm (time) {
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()
      this.form.birthday = year + '年' + month + '月' + day + '日'
      this.datePicker = false
    },
    speak (e) {
      this.datePicker = true
      this.$refs.picker.open()
    },
    getQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    getSchoolList () {
      for (let item in this.schoolList) {
        if (item === this.form.city) {
          this.school = this.schoolList[item]
          this.defaultResult = this.schoolList[item]
        }
      }
    }
  },
  created () {
    this.cityList = util.city
    this.schoolList = util.school
  },
  mounted () {
    this.form.wechat_info = {
      wechat_openid: this.$store.state.userInfo.openid,
      headimgurl: this.$store.state.userInfo.headimgurl
    }
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 300)
  }
}
</script>
<style lang="less">
#signUp {
  background-image: url('~@/assets/happyBirthday/signupBg.png');
  background-size: 115% auto;
  background-repeat: no-repeat;
  background-position: 0 0;
  height: 115vh;
  font-size: .42rem;
  .top {
    display: flex;
    justify-content: space-between;
    .top-left {
      background-image: url('~@/assets/happyBirthday/signupTop.png');
      background-size: 100% 100%;
      background-position: 0 0;
      width: 6.37rem;
      height: 6.13rem;
      margin-left: .5rem;
      margin-top: .3rem;
    }
    .top-right {
      background-image: url('~@/assets/happyBirthday/topright.png');
      background-size: 100% 100%;
      background-position: 0 0;
      width: 1.73rem;
      height: 2.45rem;
      margin-top: .5rem;
    }
  }
  .content {
    padding: .6rem;
    margin-top: -.9rem;
    .item {
      margin-top: .3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      input, select {
        height: .96rem;
        width: 6.67rem;
        margin-left: .3rem;
        font-size: .43rem;
        padding-left: 10px;
        border-radius: 5px;
        background-color: #fff;
        border: 2px solid #083760;
        outline: none;
        color: #083760;
        letter-spacing: 1px;
      }
      .city, .school {
        color: #aaa;
      }
      .changeCity, .changeSchool {
        color: #083760;
      }
      #birthday {
        height: .96rem;
        width: 6.67rem;
        margin-left: .3rem;
        font-size: .43rem;
        line-height: .90rem;
        padding-left: 10px;
        border-radius: 5px;
        border: 2px solid #083760;
        background-color: #fff;
        color: #aaa;
        text-align: left;
        letter-spacing: 1px;
      }
      .changeColor {
        color: #083760 !important;
      }
    }
    .select::after {
      display: inline-block;
      position: absolute;
      content: ' ';
      background-image: url('~@/assets/happyBirthday/triangle.png');
      background-size: 100% 100%;
      width: .37rem /* 28/75 */;
      height: .32rem /* 24/75 */;
      right: .33rem /* 10/75 */;
      top: .31rem;
    }
    .tips-wrap {
      display: inline-block;
      font-size: 10px;
      font-weight: 400;
      padding-top: .6rem;
      letter-spacing: 1px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .detail {
        width: 7rem;
      }
    }
  }
  .footer {
    text-align: center;
    .submit {
      width: 5.09rem;
      height: 1.17rem;
      margin: 0 auto;
      background-position: 0 0;
      background-size: cover;
      background-image: url('~@/assets/happyBirthday/signupButton.png');
    }
  }
}
.picker-item {
  padding: 0;
}
#canvas-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fff;
  .success-img {
    width: 9rem;
  }
}
.success {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  header {
    background-image: url('~@/assets/happyBirthday/header.png');
    width: 8.59rem /* 644/75 */;
    height: 5.87rem /* 440/75 */;
    background-size: 100% 100%;
    margin-top: .3rem;
  }
  .user-wrap {
    font-size: .45rem;
    font-weight: 500;
  }
  .qrCode {
    width: 3.15rem /* 236/75 */;
    height: 3.63rem /* 272/75 */;
    margin-top: .4rem;
  }
  .share {
    width: 5.09rem /* 382/75 */;
    height: 1.17rem /* 88/75 */;
    background-image: url('~@/assets/happyBirthday/signup-share.png');
    background-size: 100% 100%;
    margin-top: 1rem;
  }
  .logo {
    width: 6.53rem /* 490/75 */;
    height: 1.01rem /* 76/75 */;
    background-image: url('~@/assets/happyBirthday/logo.png');
    margin-top: .5rem;
    background-size: 100% 100%;
  }
}
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .7);
  .to-share {
    background-image: url('~@/assets/happyBirthday/toShare.png');
    width: 7.49rem /* 562/75 */;
    height: 10.24rem /* 768/75 */;
    background-size: 100% 100%;
    margin-left: 1.7rem;
    margin-top: 1rem;
  }
}
.picker-slot-center:nth-of-type(2) {
  display: none;
}
.picker-toolbar {
  position: relative;
}
.picker-toolbar::after {
  content: '7月';
  position: absolute;
  font-size: 18px;
  left: 4.8rem;
  top: 117px;
  color: #000;
}
.page-search {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .7);
}
.el-date-editor {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/happyBirthday/signUp.vue